// components/FollowButton.tsx
import React, { useEffect, useState } from 'react';
import { followKeychain } from 'helpers/keychain';
import { followWithWif } from 'helpers/steem';
import { isLoggedWithKeychain } from 'services/dsteem-service';
import { getUserFollowingList } from 'services/user-service';
import { useAuth } from 'helpers/authContext';

type Props = {
  author: string;
  className?: string;
  onError?: (message: string) => void;
  disabled?: boolean;
};

const FollowButton = ({ author, className, onError, disabled = false }: Props) => {
  const { user, autologin, following, updateFollowing } = useAuth();
  const [hasFollowed, setHasFollowed] = useState(false);
  const [loading, setLoading] = useState(false);

  const keychainLogin = isLoggedWithKeychain(autologin);

  useEffect(() => {
    if (!following || !author) return;

    try {
      const parsed = typeof following === 'string' ? JSON.parse(following) : following; 
      const isFollowing = parsed.some((f: any) => f.following === author);
      setHasFollowed(isFollowing);
    } catch (e) {
      onError?.('Error parsing following list');
    }
  }, [following, author]);

  const reloadFollowing = () => {
    if (user) {
      getUserFollowingList(user).then(result => updateFollowing(result));
    }
  };

  const handleFollow = async () => {
    if (!user || user === author) return;
    setLoading(true);

    const type = hasFollowed ? '' : 'blog';
    const followFn = keychainLogin ? followKeychain : followWithWif;

    try {
      const result:any = await followFn(author, type, keychainLogin ? user : autologin);

      if (result.success) {
        setHasFollowed(!hasFollowed);
        setTimeout(reloadFollowing, 10000);
      } else {
        onError?.('Follow operation failed.');
      }
    } catch (err) {
      onError?.('Error following user: ' + err);
    } finally {
      setLoading(false);
    }
  };

  if (!user || user === author) return null;

  return (
    <React.Fragment>
      {className?.includes("follow-buble") && (
        <React.Fragment>
          {!hasFollowed && (
            <span
              className={`follow-buble ${loading ? 'bounce-out' : ''}`}
              onClick={async (e) => {
                e.stopPropagation();
                e.currentTarget.classList.add('bounce-out');
                  handleFollow();
              }}
            >
              {loading ? <span className="spinner dark small" /> : <i className="fas fa-plus" />}
            </span>
          )}

        </React.Fragment>
      )}
      {!className?.includes("follow-buble") && (
        <button
          className={(hasFollowed ? 'unfollow-button' : 'follow-button')+" "+className}
          onClick={handleFollow}
          disabled={loading || disabled}
        >
            
          {loading && <span className="spinner" />}
          {!loading && (hasFollowed ? 'Unfollow' : 'Follow')}
        </button>
      )}
      
    </React.Fragment>
  );
};

export default FollowButton;
